<mat-icon
  *ngIf="color === 'white'"
  class="mt-1"
  tooltip="Options"
  [matMenuTriggerFor]="menu"
  style="font-size: 22px; color: white"
>
  more_vert
</mat-icon>
<mat-icon
  *ngIf="color === 'black'"
  class="mt-1"
  tooltip="Options"
  [matMenuTriggerFor]="menu"
  style="font-size: 22px; color: black"
>
  more_vert
</mat-icon>

<mat-menu #menu="matMenu">
  <!-- <button mat-menu-item (click)="openShareDialog(project.uuid || '')" >
    <mat-icon class="matSpanClass" >share</mat-icon> <span class="matSpanClass">Share</span>
  </button> -->
  <button mat-menu-item *ngIf="!projectSupported" (click)="requestSupport(project.uuid || '')">
    <mat-icon class="matSpanClass">email</mat-icon>
    <span class="matSpanClass">Support</span>
  </button>
  <button mat-menu-item *ngIf="projectSupported" (click)="viewSupportRequest(project.uuid || '')">
    <mat-icon class="matSpanClass">email</mat-icon>
    <span class="matSpanClass">Support</span>
  </button>
  <button *ngIf="additionalFeatures" mat-menu-item (click)="deleteProject(project.uuid || '')">
    <mat-icon class="matSpanClass">delete</mat-icon>
    <span class="matSpanClass">Delete</span>
  </button>
</mat-menu>
